module.exports = __webpack_public_path__ + "../resources/img/ic_show_bg_default.137c238a.svg";